import BottomDrawer from "components/BottomDrawer";
import ChangePasswordForm from "./components/ChangePasswordForm";

function ChangePassword({ open, onClose }) {
  return (
    <BottomDrawer
      dir="rtl"
      title="تغییر رمز عبور"
      open={open}
      onClose={onClose}
      maxWidth="xs"
    >
      <ChangePasswordForm onClose={onClose} />
    </BottomDrawer>
  );
}

export default ChangePassword;
